import {useAppContext} from "../../../../context/AuthContext";
import {useState} from "react";
import {Teacher, User} from "../../../../controller";
import ChangePasswordType from "../../../../interfaces/change-password/ChangePasswordType";
import MessageType from "../../../../utils/MessageType";
import {INIT_VALUES} from "./config";
import NotificationsSettingsType from "../../../../interfaces/notification/NotificationsSettingsType";
import ExpressionSettingsDto from "../../../../interfaces/expression/ExpressionSettingsDto";
import {useEffectOnce} from "../../../../utils/Utils";

interface SettingsServiceType {
    handleOnSubmit: (val: ChangePasswordType, {resetForm}: any) => void;
    handleOnSubmitNotifications: (val: NotificationsSettingsType, {resetForm}: any) => void;
    expressionSettings: ExpressionSettingsDto | undefined;
    handleChangeUseFeedbackNotifications: (val: boolean) => void;
}

export default function SettingsService(): SettingsServiceType {
    const {showMessage} = useAppContext();
    const [expressionSettings, setExpressionSettings] = useState<ExpressionSettingsDto>();

    const handleOnSubmit = (values: ChangePasswordType, {resetForm}: any) => {
        User.changePassword(values)
            .then(({data}: any) => {
                if (data?.message) {
                    resetForm(INIT_VALUES);
                    showMessage(data.message, MessageType.SUCCESS);
                }
            })
            .catch((err: any) => console.error(err));
    };

    const handleOnSubmitNotifications = (values: NotificationsSettingsType, {resetForm}: any) => {
        Teacher.updateExpressionSettings(values.lost, values.notClear, values.tooHard, values.tooSimple, values.great)
            .then(({data}: any) => {
                if (data?.message) {
                    showMessage(data.message, MessageType.SUCCESS);
                }
            })
            .catch((err: any) => {
                resetForm(expressionSettings);
                console.error(err)
            });
    };

    const handleChangeUseFeedbackNotifications = (val: boolean) => {
        if (expressionSettings) {
            Teacher.updateExpressionSettingsFeedbackUsage(val)
                .then(({data}: any) => {
                    if (data?.message) {
                        expressionSettings.useFeedbackNotifications = val;
                        setExpressionSettings({...expressionSettings});
                    }
                })
                .catch((err: any) => console.error(err))
        }
    }

    useEffectOnce(() => {
        getExpressionSettings();
    })

    const getExpressionSettings = () => {
        Teacher.getExpressionSettings()
            .then(({data}: any) => {
                if (data?.message) {
                    setExpressionSettings(data.data);
                } else {
                    console.error(data);
                }
            }).catch((err) => console.error(err));
    }

    return {handleOnSubmit, handleOnSubmitNotifications, expressionSettings, handleChangeUseFeedbackNotifications};
}

export type {SettingsServiceType};
